var navegacao = function () {
    var defineAtivo = function ($el) {
        $el.closest("nav").find("li").removeClass("active");
        $el.closest("nav").find("a").css("font-weight", "normal");

        if ($el.tagName === "A") {
            $el.css("font-weight", "bold");
        } else {
            $el.closest("a").css("font-weight", "bold");
        }

        $el.closest("li").addClass("active");
        $el.closest("ul").closest("li").addClass("active");
        $el.closest("ul").closest("li").find("> a").css("font-weight", "bold");
    };

    var defineTitulo = function ($el) {
        if ($el) {
            if ($el.prop("tagName") !== "A") {
                $el = $el.closest("A");
            }

            document.title = $el.text().trim() + " - Masut";
        }
    };

    var carregaConteudoLoad = function (url, local, parametros, callback, $elementoMenu, ehRetornoBrowser) {
        $(local).block();
        var $elemento = $elementoMenu && $elementoMenu.length > 0 ? $elementoMenu : event && event.target ? $(event.target) : undefined;
        var ehMenu = $elemento && $elemento.closest("nav.sidebar").length > 0;
        if (parametros) {
            $(local).load(url, parametros, function (responseText, textStatus, jqXHR) {
                if (jqXHR.status === 200) {
                    msPanelTool.initAll();
                    bootstrapComponents.init($(local));
                    if (ehMenu) {
                        if (!ehRetornoBrowser) {
                            var urlPartida = url.split("/"),
                                controller = "/";
                            if (urlPartida.length === 3) {
                                controller += urlPartida[1] + "/" + urlPartida[2];
                            } else {
                                controller += urlPartida[1];
                            }

                            var obj = { Title: controller, Url: controller };
                            history.pushState(obj, obj.Title, obj.Url);
                        }
                        
                        defineTitulo($elemento);
                        defineAtivo($elemento);
                    }

                    if (callback && util.isFunction(callback)) {
                        callback();
                    }
                } else if (jqXHR.status === 403) {
                    notificacao.erro("Você não tem autorização para acessar essa função.");
                } else {
                    notificacao.erro("Erro! Ocorreu um erro interno no servidor.");
                }

                $(local).unblock();
            });
        } else {
            $(local).load(url, function (responseText, textStatus, jqXHR) {
                if (jqXHR.status === 200) {
                    msPanelTool.initAll();
                    bootstrapComponents.init($(local));

                    if (ehMenu) {
                        if (!ehRetornoBrowser) {
                            var urlPartida = url.split("/"),
                                controller = "/";
                            if (urlPartida.length === 3) {
                                controller += urlPartida[1] + "/" + urlPartida[2];
                            } else {
                                controller += urlPartida[1];
                            }

                            var obj = { Title: controller, Url:  controller };
                            history.pushState(obj, obj.Title, obj.Url);
                        }

                        defineTitulo($elemento);
                        defineAtivo($elemento);
                    }

                    if (callback && util.isFunction(callback)) {
                        callback();
                    }
                } else if (jqXHR.status === 403) {
                    notificacao.erro("Você não tem autorização para acessar essa função.");
                } else {
                    notificacao.erro("Erro! Ocorreu um erro interno no servidor.");
                }

                $(local).unblock();
            });
        }
    };

    return {
        carregaConteudoLoad: carregaConteudoLoad,
        defineAtivo: defineAtivo,
        defineTitulo: defineTitulo
    };
}();

    var navegacaoMenu = function () {
    var carregaItemMenu = function (url, buscarItemMenuPelaUrl, ehRetornoBrowser) {
        if (buscarItemMenuPelaUrl) {
            if (url.lastIndexOf("?") > 0)
                url = url + "&iframe=true";
            else
                url = url + "?iframe=true";
            var $item = $("#menuLateralPrincipal a[data-url='" + url + "']");
            //window.location.href = url;
            navegacao.carregaConteudoLoad(url, $("#conteudoPrincipal"), null, null, $item, ehRetornoBrowser);
        } else {
            //window.location.href = url;
            navegacao.carregaConteudoLoad(url, $("#conteudoPrincipal"));
        }
    };

    var carregaItemMenuNovaAba = function(url) {
        var win = window.open(url, "_blank");
        win.focus();
    };

    var carregaItemMenuNovaJanela = function(url) {
        var win = window.open(url, "_blank", "location=yes");
        win.focus();
    };

    var carregaIframe = function(url) {
        $("#conteudoPrincipal").html('<iframe width="100%" height="768px" src="' + url + '"></iframe>');
    };

    return {
        carregaItemMenuNovaJanela: carregaItemMenuNovaJanela,
        carregaItemMenuNovaAba: carregaItemMenuNovaAba,
        carregaItemMenu: carregaItemMenu,
        carregaIframe: carregaIframe
    }
}();